// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // 建置環境標記：SSR 部署腳本會掃描 web bundle 驗證此字串，勿改動格式
  BUILD_ENV: 'eline-build-env=ssr-dev',

  // BASE_URL: '', // 使用 angular proxy
  // BASE_URL: 'http://localhost:3000',
  // GRAPHQL_END_POINT: 'http://localhost:3000/v1/graphql',

  BASE_URL: 'https://api-dev.omnihealth.com.tw',
  BASE_WEBSITE_URL: 'https://app-dev.omnihealth.com.tw',
  GRAPHQL_END_POINT: 'https://api-dev.omnihealth.com.tw/v1/graphql',

  // BASE_URL: 'https://3082-124-218-35-36.ngrok.io',
  // GRAPHQL_END_POINT: 'https://3082-124-218-35-36.ngrok.io/v1/graphql',

  // default cursor: 當讀取不到 cursor 資料時, 給予default value days(目前設定 0 表示全部讀取, 設定 -365 表示讀取一年內的資料)
  // 未定應時, cursor為0
  DEFAULT_CURSOR: {
    Post: 0,
    Expert: 0,
    Hospital: 0,
  },

  // 推薦碼有效天數設定
  REFERRAL_CODE_EXPIRATION_DAYS: 3,

  // 是否啟用 Web_App, build APP時 手動設定為 true
  // v3.1 之後版本都要設定為 true, 未來再移除此設定
  WEB_APP_MODE: true,

  // 是否為網頁版(將隱藏孕關懷、待產清單、餵養紀錄、生長紀錄)
  WEB_FLAG: true,

  // LINE設定  *** callback url 不可以用 hash # ***
  line_client_id: '2010174354',
  // line_callback_login_url: 'http://127.0.0.1:8300/login',
  // line_callback_register_url: 'http://127.0.0.1:8300/register',
  line_callback_login_url: 'https://app-dev.omnihealth.com.tw/login',
  line_callback_register_url: 'https://app-dev.omnihealth.com.tw/register',
  line_scope: 'profile%20openid%20email',
  line_client_secret: 'b13486564673b9c5d6e1734cea79913b',

  // Peter's LINE設定(PeterLai商號測試)
  // line_client_id: '1657313860',
  // line_callback_url: 'http://localhost:8300/login',
  // line_scope: 'profile%20openid%20email',
  // line_client_secret: '20d02c63719be7eda825fcee7d967e0c',

  // ****************************************************************************************
  // Eline 設定
  // ****************************************************************************************
  // API_URL: 'https://app01.mommycareyou.com/api',
  // APP_VERSION_CHECK_URL: 'https://appinfo.mommycareyou.com/app/prod/app_version_patient.json',
  // NEWS_URL: 'https://appinfo.mommycareyou.com/app/prod/news.json',
  // OM_STATUS_URL: 'https://appinfo.mommycareyou.com/app/prod/omstatus.json',
  // RESET_PASSWORD_URL: 'https://app01.mommycareyou.com/resetpassword',
  // PUBLIC_POST_HOST: 'https://app01.mommycareyou.com/post/',
  // DEBUG_FLAG: false,
  // SELF_DOMAIN_URL: ['mommycareyou.com','mommycare.cc'],  // 自己的domain list, 會夾帶 auth_token 的判斷
  // firebaseConfig: {
  //   apiKey: 'AIzaSyBf7srj3yQPXNoKIYqzaTELa6eUUP8Ofdg',
  //   authDomain: 'mommycareyouprod.firebaseapp.com',
  //   databaseURL: 'https://mommycareyouprod-default-rtdb.asia-southeast1.firebasedatabase.app',
  //   projectId: 'mommycareyouprod',
  //   storageBucket: 'mommycareyouprod.appspot.com',
  //   messagingSenderId: '58273204584',
  //   appId: '1:58273204584:web:7bb428e8e333ad0132aedd',
  //   measurementId: 'G-9FB6M1465E',
  // },
  // DEBUG_API_URL: 'https://app01test.mommycareyou.com/api',
  // WP_API_URL: 'https://www.mommycare.cc/wp-json',
  // DEFAULT_TEAM_ID: 4, // 預設要加入的醫療團隊id (ex: 孕媽咪小幫手)

  // API_URL: 'https://app01test.mommycareyou.com/api',
  API_URL: 'https://app01-dev.omnihealth.com.tw/api',
  APP_VERSION_CHECK_URL:
    'https://appinfo.omnihealth.com.tw/app/test/app_version_patient.json',
  NEWS_URL: 'https://appinfo.omnihealth.com.tw/app/test/news.json',
  OM_STATUS_URL: 'https://appinfo.omnihealth.com.tw/app/test/omstatus.json',
  RESET_PASSWORD_URL: 'https://app01-dev.omnihealth.com.tw/resetpassword',
  PUBLIC_POST_HOST: 'https://app01-dev.omnihealth.com.tw/post/',
  DEBUG_FLAG: true,
  SELF_DOMAIN_URL: ['mommycareyou.com', 'mommy-care.knockers.tw'], // 自己的domain list, 會夾帶 auth_token 的判斷
  MALLDJ_URL: ['www.malldj.com'], //異網url
  firebaseConfig: {
    apiKey: 'AIzaSyCTvyTzYBy6ZO9KdNc0keTaI9kkMoweedk',
    authDomain: 'omniappdev-688d5.firebaseapp.com',
    databaseURL:
      'https://omniappdev-688d5-default-rtdb.asia-southeast1.firebasedatabase.app',
    projectId: 'omniappdev-688d5',
    storageBucket: 'omniappdev-688d5.firebasestorage.app',
    messagingSenderId: '527778016880',
    appId: '1:527778016880:web:fa0b7b9496de7ac4810eb5',
    measurementId: 'G-TRF3BYEM4Y',
  },
  DEBUG_API_URL: 'https://eline.dev.omnihealth.com.tw/api',
  WP_API_URL: 'https://mommy-care.knockers.tw/wp-json',
  DEFAULT_TEAM_ID: 5, // 預設要加入的醫療團隊id (ex: 全馨護),

  // 會員邀請推薦註冊的 URL
  REFERRAL_REGISTER_URL: 'https://app-dev.omnihealth.com.tw/register',

  // 分享 content(eg pgc,video,ec-product) 的 domain url
  SHARELINK_DOMAIN: 'https://app-dev.omnihealth.com.tw/',

  // app deeplink domain
  APP_DEEPLINK_DOMAIN: 'https://app-dev.omnihealth.com.tw',

  // ＡccessToken 預設為1年, 若效期小於以下參數, 則將進行 refresh
  ACCESS_TOKEN_EXPIRED_IN_DAYS: 90,

  // EC 相關
  EC_API_URL: 'https://api.ec.dev.mommycareyou.com',
  EC_IMAGE_CDN_URL: 'https://api.ec.dev.mommycareyou.com/cdn/',
  EC_COMMODITY_PAGE_SIZE: 50, // EC商品list 每頁筆數
  EC_SEARCH_COMMODITY_PAGE_SIZE: 50, // EC查詢商品list 每頁筆數
  EC_BILLLIST_PAGE_SIZE: 5, // 會員訂單list 每頁筆數
  EC_COIN_HIST_PAGE_SIZE: 10, // 會員咪幣紀錄 每頁筆數
  EC_PAYMENT_URL:
    'https://api.ec.dev.mommycareyou.com/Portal/Commerce/ThirdPartyPayment',
  EC_PAYMENT_URL_WEB:
    'https://api.ec.dev.mommycareyou.com/Portal/Commerce/ThirdPartyPaymentWeb',

  VENDER_API_URL: 'https://vender-dev.omnihealth.com.tw/api',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
